import Batches from "pages/dashboard/shared/Batches/Batches";
import React from "react";

const AdminBatches = () => {
  return <Batches />;
};

export default AdminBatches;
